import React from 'react';
import {
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Checkbox,
  ListItemIcon,
} from '@mui/material';
import { formatCompoundOperatorDisplayString } from '../helpers';
import { QueryableFieldsQuery } from '../../../../types/generated-types';
import { IEntityCriteriaCompoundOperator } from '../../../../common/types/shared/entitySelection';

interface CompoundOperatorListProps {
  operators: IEntityCriteriaCompoundOperator[];
  targetModel: string;
  fieldsData: QueryableFieldsQuery['queryableFields'];
  onOperatorEdit: (operator: IEntityCriteriaCompoundOperator) => void;
  selectedOperators: Set<string>;
  onOperatorSelect: (operatorId: string) => void;
}

export const CompoundOperatorList: React.FC<CompoundOperatorListProps> = ({
  operators,
  targetModel,
  fieldsData,
  onOperatorEdit,
  selectedOperators,
  onOperatorSelect,
}) => {
  return fieldsData ? (
    <List sx={{ padding: '0px', margin: '0px', overflow: 'auto' }}>
      {operators.map((operator) => (
        <ListItemButton
          key={operator.id}
          onClick={() => onOperatorEdit(operator)}
        >
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={selectedOperators.has(operator.id)}
              onClick={(e) => {
                e.stopPropagation();
                onOperatorSelect(operator.id);
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                component="pre"
                sx={{
                  fontFamily: 'inherit',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  margin: 0,
                }}
              >
                {formatCompoundOperatorDisplayString(
                  operator,
                  targetModel,
                  fieldsData,
                )}
              </Typography>
            }
          />
        </ListItemButton>
      ))}
    </List>
  ) : null;
};
